"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendResourceAjaxRequest = sendResourceAjaxRequest;
var _requestOptions = require("./request-options");
var _request = require("./request");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Sends AJAX request to fetch a static resource
 *
 * @param {string} url The URL of the resource
 * @param {object} options JS object containing the result callbacks
 */
function sendResourceAjaxRequest(url, options) {
  var opts = (0, _requestOptions.createResourceRequestOptions)('sendResourceAjaxRequest', options);
  if (!opts) {
    return;
  }
  (0, _request.ajaxRequest)(url, opts);
}
//# sourceMappingURL=resource-request.js.map